import * as images from '../../assets/experiencesImages.export';

const EXPERIENCES_DATA = {
  experiences: [
    {
      id: 1,
      title: 'Cynorix',
      link: 'https://www.cynorix.com/',
      icon: images.cynorixIcon,
      languages: ['Javascript (React.JS, React Native, Node.JS)', 'CSS (Bootstrap)'],
      tools: ['Redux', 'Firebase', 'MongoDB', 'Stripe', 'Twilio'],
      time: 'September 2021 ~ December 2021',
      description: '',
    },
    {
      id: 2,
      title: 'FIRST Robotics',
      link: 'https://www.firstinspires.org/robotics/frc',
      icon: images.roboticsIcon,
      languages: ['G graphical language by NI LabView'],
      tools: ['NI LabView'],
      time: 'September 2017 ~ June 2018',
      description: 'Worked with cross-functional teams and a programming team of 10 to create a manually controlled robot using NI LabVIEW that ranked 11th out of 38 with a 70% win rate in a regional FRC event.',
    },
  ]
}

export default EXPERIENCES_DATA;
